<template>
  <w-icon-wrapper
    :width="21.333"
    :height="16"
    icon-name="work-checkmark-icon"
    viewBox="0 0 21.333 16"
  >
    <g
      id="_78_Check_Icon"
      data-name="78 Check_Icon"
      transform="translate(-299.833 -465.207)"
    >
      <path
        id="Pfad_55582"
        data-name="Pfad 55582"
        d="M7.867,19.467a1.719,1.719,0,0,0,2.489,0L22.8,7.022a1.719,1.719,0,0,0,0-2.489,1.719,1.719,0,0,0-2.489,0l-11.2,11.2L5.022,11.644a1.719,1.719,0,0,0-2.489,0,1.719,1.719,0,0,0,0,2.489Z"
        transform="translate(297.833 461.207)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckmark' };
</script>
